import { render } from "./VvRedeemCard.vue?vue&type=template&id=be697812&scoped=true"
import script from "./VvRedeemCard.vue?vue&type=script&lang=js"
export * from "./VvRedeemCard.vue?vue&type=script&lang=js"

import "./VvRedeemCard.vue?vue&type=style&index=0&id=be697812&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be697812"]])

export default __exports__